export type Success<T> = {
  data: T;
  error: null;
};

export type Failure<E> = {
  data: null;
  error: E;
};

export type Result<T, E = Error> = Success<T> | Failure<E>;

export async function tryCatch<T, E = Error>(promise: Promise<T>): Promise<Result<T, E>> {
  try {
    const data = await promise;

    return { data, error: null };
  } catch (error) {
    return { data: null, error: error as E };
  }
}

export function tryCatchSync<T, E = Error>(func: () => T): Result<T, E> {
  try {
    const data = func();

    return { data, error: null };
  } catch (error) {
    return { data: null, error: error as E };
  }
}

export function isError<T, E = Error>(result: Result<T, E>): result is Failure<E> {
  return result.error !== null;
}

export function isSuccess<T, E = Error>(result: Result<T, E>): result is Success<T> {
  return result.error === null;
}
